import { SidebarContent } from "../generation/sidebar.generator";
import { StimuliBank } from "../generation/stimuli.bank";
import { PostData } from "../posts/post.models";

export interface StimuliHookProps {
  subjectId: string;
  conditionName: string;
  disableMultistage: boolean;
  bank: StimuliBank;
}

type PostGenerator = (
  props: StimuliHookProps,
  standard: PostData[],
) => PostData[];
type SidebarGenerator = (
  props: StimuliHookProps,
  standard: SidebarContent,
) => SidebarContent;
type Metadata = {
  name: string;
  data: { [key: string]: any };
};
type MetadataGenerator = (props: StimuliHookProps) => Metadata;

class HookRegistry {
  private postGenerators: PostGenerator[] = [];
  private sidebarGenerators: SidebarGenerator[] = [];
  private metadataGenerator: MetadataGenerator[] = [];

  public registerPostGenerator(generator: PostGenerator) {
    this.postGenerators.push(generator);
  }

  public registerSidebarGenerator(generator: SidebarGenerator) {
    this.sidebarGenerators.push(generator);
  }

  public registerMetadataGenerator(generator: MetadataGenerator) {
    this.metadataGenerator.push(generator);
  }

  public generatePosts(props: StimuliHookProps, standard: PostData[]) {
    var current = standard;

    for (const generator of this.postGenerators) {
      current = generator(props, current);
    }

    return current;
  }

  public generateSidebar(props: StimuliHookProps, standard: SidebarContent) {
    var current = standard;

    for (const generator of this.sidebarGenerators) {
      current = generator(props, current);
    }

    return current;
  }

  public generateMetadata(props: StimuliHookProps): { [key: string]: any } {
    const metadata: Map<string, any> = new Map();

    for (const generator of this.metadataGenerator) {
      const result = generator(props);
      metadata.set(result.name, result.data);
    }

    return metadata;
  }
}

const registry = new HookRegistry();
window.HookRegistry = registry;
export default registry;
